// Contact-form transport. Contract with POST /api/contact (same origin):
// 200 {ok:true}; 400/429/502 {error:string}.
export type ContactValues = { name: string; email: string; message: string; website: string };
export type ContactResult = { ok: true } | { ok: false; error: string };

export const CONTACT_EMAIL = "hello@rounakkumarsingh.com";

export async function sendContact(
  values: ContactValues,
  fetchImpl: typeof fetch = fetch,
): Promise<ContactResult> {
  try {
    const res = await fetchImpl("/api/contact", {
      method: "POST",
      headers: { "content-type": "application/json" },
      body: JSON.stringify(values),
    });
    let body: unknown = null;
    try {
      body = await res.json();
    } catch {
      /* non-JSON body */
    }
    const err =
      body && typeof body === "object" && typeof (body as { error?: unknown }).error === "string"
        ? (body as { error: string }).error
        : null;
    if (res.ok && !err) return { ok: true };
    return { ok: false, error: err ?? `The message could not be sent (status ${res.status}).` };
  } catch {
    return { ok: false, error: "Network error: the message could not be sent." };
  }
}
